module.exports = __webpack_public_path__ + "static/IMG-20200808-WA0006-8211c24acd0a211492f237539bb8c484.jpg";